<template>
  <div>
    <Modal v-bind="$attrs" v-on="$listeners" :xIconDisabled="true">
      <template #action>
        <div class="page">

          <div class="flex justify-between">
            <div class="font-bold">{{ siteName }}</div>
            <PrimaryButton text="＋ カテゴリー追加" size="sm" class="m-1" @click="addCategory()"/>
          </div>

          <!-- 並び替え -->
          <div class="flex mb-1">
            <span class="text-gray-700 font-bold text-sm mt-auto">並べ替え</span>
            <Toggle v-model="sortable" size="" class="ml-1 mt-auto inline-block"/>
          </div>

          <div class="w-full list" ref="list">
            <table class="w-full">
              <thead class="bg-colu">
                <tr>
                  <th></th>
                  <th>カテゴリー</th>
                  <th>項目</th>
                  <th></th>
                </tr>
              </thead>

              <draggable
                ref="tableBody"
                :list="list"
                direction="vertical"
                handle=".row-drag-handle"
                tag="tbody"
                class="bg-white divide-y divide-gray-200"
              >
                <tr v-for="(row, i) in list" :key="i" class="bg-gray-50">

                  <!-- 並べ替え -->
                  <td class="border-b border-gray-400">
                    <div v-if="sortable" class="row-drag-handle p-2">
                      <MenuIcon></MenuIcon>
                    </div>
                  </td>

                  <!-- カテゴリー -->
                  <td class="p-2 border-b border-gray-400">

                    <!-- 項目追加 -->
                    <div class="text-blue-800 border-b border-blue-800 mb-4 w-fit cursor-pointer" @click="addItem(row)">
                      <Icon
                        iconName="PlusSm"
                        class="w-4 h-4 inline"
                      />
                      項目追加
                    </div>

                    <!-- カテゴリー -->
                    <input
                      type="text"
                      class="border-gray-300 rounded w-full font-bold text-blue-700"
                      :class="!row.category?'bg-red-200':''"
                      v-model="row.category"
                    />
                  </td>

                  <!-- 項目 -->
                  <td class="border-b border-gray-400">
                    <draggable
                      :list="row.items"
                      group="items"
                      handle=".item-drag-handle"
                      tag="div"
                    >
                    <div
                      v-for="(item, j) in row.items"
                      :key="i+'item'+j"
                      class="flex items-center my-3">

                      <div v-if="sortable" class="item-drag-handle p-2">
                        <MenuIcon></MenuIcon>
                      </div>

                      <div v-else><TrashIcon class="text-gray-400 hover:text-gray-500 active:text-gray-600 w-7 h-7" @click="deleteItem(row, j)" /></div>
                      

                      <input
                        type="text"
                        class="rounded w-full text-gray-700 border-gray-300  ml-2 mr-1 my-0.5"
                        :class="!item.item?'bg-red-200':''"
                        v-model="item.item"
                      />
                    </div>
                    </draggable>
                  </td>

                  <!-- カテゴリー削除 -->
                  <td  class="p-2 border-l border-b border-gray-400">
                    <TrashIcon class="text-gray-400 hover:text-gray-500 active:text-gray-600 w-7 h-7" @click="deleteCategory(i)" />
                  </td>
                </tr>

              </draggable>
            </table>
          </div>

          <div class="m-1 flex gap-5">
            <SecondaryButton text="閉じる" size="normal" class="flex-1" @click="closedModal()"/>
            <PrimaryButton text="保存" size="normal" class="flex-1" @click="save()"/>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>

import Modal from '@components/Modal.vue'
import Icon from '@components/Icon.vue'
import Toggle from '@components/Toggle.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import SecondaryButton from '@components/SecondaryButton.vue'
import draggable from "vuedraggable"
import { TrashIcon, MenuIcon } from '@vue-hero-icons/solid'
import * as backend from '@libs/backend'

export default {
  components: {
    Modal,
    Icon,
    Toggle,
    PrimaryButton,
    SecondaryButton,
    draggable,
    TrashIcon,
    MenuIcon,
  },

  props: {
    siteCode: {
      type: String
    },
    siteName: {
      type: String
    },
    open: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      reload: 0,
      list: [{ category: '', open: true, items: [] }],
      sortable: false
    }
  },

  watch: {
    open() {
      if (this.open) {
        this.getTarget()
      }
    },
  },

  computed: {
    userId() {
      return this.$store.getters.user.id
    }
  },

  methods: {
    /**
     * 表示するデータ取得
     */
    async getTarget() {
      if (this.siteCode) {
        this.loading = true
        // 対象物件の詳細情報取得
        const res = await backend.searchData('siteOutline/getItem', { siteCode: this.siteCode })

        this.setItem(res.data.data || [])
        this.loading = false
      }
    },

    /**
     * データを画面表示の形に成形
     * @param list
     */
    setItem(list) {
      const map = new Map()

      for (const row of list) {
        if (!map.has(row.category)) {
          map.set(row.category, {
            category: row.category,
            open: false,
            items: []
          })
        }

        map.get(row.category).items.push({ item: row.item, id: row.id })
      }

      this.list = [...map.values()]
    },

    /**
     * カテゴリー開閉
     * @param row
     */
    clickOpen(row) {
      if (row.open) {
        row.open = false
      } else {
        row.open = true
      }

      this.reload++
    },

    /**
     * カテゴリー追加
     */
    addCategory() {
      this.list.push({ category: '', items: [{ item: '' }] })

      this.$nextTick(() => {
        this.$refs.list.scrollTo({
          top: this.$refs.list.scrollHeight,
          behavior: 'smooth'
        })
      })
    },

    /**
     * 項目追加
     */
    addItem(row) {
      row.items.push({ item: '' })
      this.reload++
    },

    /**
     * カテゴリー削除
     * @param i 削除対象インデックス
     */
    deleteCategory(i) {
      if (window.confirm('このカテゴリーを削除してよろしいですか？')) {
        this.list.splice(i, 1)
        this.reload++
      }
    },

    /**
     * 項目削除
     * @param i 対象インデックス
     */
    deleteItem(row, i) {
      row.items.splice(i, 1)
      if (!row.items || !row.items.length) {
        row.items = [{ item: '' }]
      }
    },

    /**
     * 保存
     */
    async save() {
      const update = []
      const insert = []
      let sortNo = 0

      for (let i = 0; i < this.list.length; i++) {
        const row = this.list[i]
        const category = row.category

        if (!category) {
          alert((i-1) + '番目のカテゴリー名が未入力です。')
          return
        }
        
        let itemName = []
        
        for (let j = 0; j < row.items.length; j++) {
          sortNo++
          const it = row.items[j]
          if (!it.item) {
            alert(category + 'の中の項目名が未入力のものがあります。')
            return
          }

          if (itemName.includes(it.item)) {
            alert(category + 'の中の項目 「' + it.item + '」 が重複しています。同じカテゴリー内で項目名の重複はできません。')
            return
          }

          itemName.push(it.item)

          if (it.id) {
            update.push({
              category,
              id: it.id,
              item: it.item,
              sortNo
            })
          } else {
            insert.push({
              category,
              item: it.item,
              sortNo
            })
          }
        }
      }
        this.loading = true
        await backend.postData('siteOutline/savePhotoItem', { siteCode: this.siteCode, update, insert, userId: this.userId })
        this.$emit('getData')
        this.loading = false
        this.closedModal()
    },

    /**
     * 初期化
     */
    closed() {
      this.list = []
    },

    /**
     * 閉じる
     */
    closedModal() {
      this.$emit('closed')
      this.closed()
    }

  }
}
</script>
<style scoped>
.page {
  font-size: 15px;
  margin: 0 30px;
}

.list {
  max-height: calc(100dvh - 250px);
  overflow: auto;
  margin-bottom: 12px;
  border: 1px solid rgb(209, 206, 206);
}

.row-drag-handle, .item-drag-handle {
  cursor: ns-resize;
}

.bg-colu {
  background: #edecf7;
}

.bg-blue {
  background: rgb(243 247 249);
}
</style>